import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  path?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          {index > 0 && <i className="ri-arrow-right-s-line text-foreground-400" />}
          {item.path ? (
            <Link to={item.path} className="cursor-pointer transition-colors hover:text-primary-700">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-700">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}